import React from 'react';
import {
  Route,
  Routes,
  BrowserRouter as Router,
  Navigate,
  useNavigate,
  useParams,
} from 'react-router-dom';
import './App.css'
import './reset.css'
import AsyncComponent from './AsyncComponent.jsx';

// import Rout from './component/Route';
// import Login from './component/Auth/Login';  //登录
// import SetInfo from './component/Auth/SetInfo';  // 完善资料
// import HomeIndex from './component/Home/HomeIndex';  // 答题
// import UserIndex from './component/User/UserIndex';  // 个人中心
// import PaperList from './component/Home/PaperList';  // 试卷列表
// import AnswerReady from './component/Home/AnswerReady';  // 答题准备
// import Answer from './component/Home/Answer';  // 答题
// import Result from './component/Home/Result';  //结果
// import MyPaperList from './component/User/MyPaperList';  //我的试卷
// import Wrong from './component/User/Wrong';  //我的错题
// import WrongDetail from './component/User/WrongDetail';  //错题详情
// import ClockList from './component/User/ClockList';  //打卡记录
// import ClockListDetail from './component/User/ClockListDetail';  //打卡记录详情
// import Fank from './component/User/Fank';  // 问题反馈
// import ReportDetail from './component/User/ReportDetail';  //报告详情
// import About from './component/User/About';
import Ajax from './class/Ajax';
// import wx from 'weixin-js-sdk'
global.Ajax=new Ajax();

const Rout=AsyncComponent(()=>import('./component/Route'));
const Login=AsyncComponent(()=>import('./component/Auth/Login'));
const SetInfo=AsyncComponent(()=>import('./component/Auth/SetInfo'));
const HomeIndex=AsyncComponent(()=>import('./component/Home/HomeIndex'));
const PaperList=AsyncComponent(()=>import('./component/Home/PaperList'));
const AnswerReady=AsyncComponent(()=>import('./component/Home/AnswerReady'));
const Answer=AsyncComponent(()=>import('./component/Home/Answer'));
const Result=AsyncComponent(()=>import('./component/Home/Result'));
const UserIndex=AsyncComponent(()=>import('./component/User/UserIndex'));
const MyPaperList=AsyncComponent(()=>import('./component/User/MyPaperList'));
const Wrong=AsyncComponent(()=>import('./component/User/Wrong'));
const WrongDetail=AsyncComponent(()=>import('./component/User/WrongDetail'));
const ClockList=AsyncComponent(()=>import('./component/User/ClockList'));
const ClockListDetail=AsyncComponent(()=>import('./component/User/ClockListDetail'));
const Fank=AsyncComponent(()=>import('./component/User/Fank'));
const ReportDetail=AsyncComponent(()=>import('./component/User/ReportDetail'));
const About=AsyncComponent(()=>import('./component/User/About'));

const WrapComps = (props)=> {
	let navigate = useNavigate();
	let params = useParams();
	let Element = props.el
	return <Element params={params} navigate={navigate} {...props} />
}

export default class App extends React.Component {
	constructor(props){
		super(props)
		this.state={
			path: '',
		}
	}
	componentDidMount(){
		
		let path='/login';
		if(localStorage.getItem('answer_token')){
			path="/rout/home"
			
		}
		this.setState({ path });
	}
	render(){
		return(
			<React.Fragment>
				<Router>
					<Routes>
						<Route path='/rout' element={<Rout />}>
							<Route path="home" element={<WrapComps el={HomeIndex} />} />
							<Route path="user" element={<WrapComps el={UserIndex} />} />
						</Route>
						<Route path="/login"  element={<WrapComps el={Login} />} />
						<Route path="/setinfo/:openid" element={<WrapComps el={SetInfo} />} />
						<Route path="/paperlist/:id/:type" element={<WrapComps el={PaperList} />} />
						<Route path="/answerready/:data" element={<WrapComps el={AnswerReady} />} />
						<Route path="/answer/:id/:date/:type" element={<WrapComps el={Answer} />} />
						<Route path="/result/:id/:type" element={<WrapComps el={Result} />} />
						<Route path="/mypaperlist" element={<WrapComps el={MyPaperList} />} />
						<Route path="/wrong" element={<WrapComps el={Wrong} />} />
						<Route path="/wrongdetail" element={<WrapComps el={WrongDetail} />} />
						<Route path="/clocklist" element={<WrapComps el={ClockList} />} />
						<Route path="/clocklistdetail/:id" element={<WrapComps el={ClockListDetail} />} />
						<Route path="/fank" element={<WrapComps el={Fank} />} />
						<Route path="/reportdetail/:report_no" element={<WrapComps el={ReportDetail} />} />
						<Route path="/about" element={<WrapComps el={About} />} />
						{/* <Route path="/home" element={<WrapComps el={HomeIndex} />}>
							<Route path="home" element={<WrapComps el={HomeIndex} ref={this.homeRef} />}></Route>
						</Route> */}

						{/* 重定向 */}
						<Route path="" element={<Navigate to={this.state.path} />} />
						{/* <Route path="" element={<Navigate to="/login" />} /> */}
					</Routes>
				</Router>
			</React.Fragment>
		)
	}
}
